import {t} from 'i18n-js';
export const DATE_MASK = 'YYYY-MM-DDThh:mm:ss';
export const EU_DATE = 'DD.MM.YYYY';
export const EU_TIME = 'hh:mm:ss';
export const EU_DATE_TIME = 'DD.MM.YYYY hh:mm:ss';

export const statuses = {
  active: 1,
  inProgress: 2,
  completed: 3,
  archive: 4,
  newOrder: '-1',
};

export const statusesMap = {
  [statuses.active]: t('LeadTabCart.active'),
  [statuses.inProgress]: t('LeadTabCart.inProgress'),
  [statuses.completed]: t('LeadTabCart.completed'),
  [statuses.archive]: t('LeadTabCart.archive'),
};

export const PAY_TYPES = {
  ONLINE_PAY: 'ONLINE',
  CASH_PAY: 'CASH',
  CARD_PAY: 'CARD',
  DEPOSIT: 'DEPOSIT',
  CARD_OR_CASH_PAY: 'CARD CASH'
};

export const PAY_NAMES = {
  [PAY_TYPES.ONLINE_PAY]: t('LeadTabCart.onlinePay'),
  [PAY_TYPES.CARD_PAY]: t('LeadTabCart.cardPay'),
  [PAY_TYPES.CASH_PAY]: t('LeadTabCart.cashPay'),
  [PAY_TYPES.CARD_OR_CASH_PAY]: t('LeadTabCart.cardOrCashPay'),
};

export const calcDecimal = (val1, val2) => {
  return (((val1 * 100) + (val2 * 100)) / 100);
};

export const dotToComma = (value) => {
  return value.toString().replace('.', ',');
};

export const commaToDot = (value) => {
  return value.toString().replace(',', '.');
};
